import Vue from 'vue'
import App from './App.vue'
import VuereSource from 'vue-resource'
import infiniteScroll from 'vue-infinite-scroll'
import api from './api' // 导入api接口
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import cookie from './utils/cookies.js'
import uid from './utils/uid.js'
import jsencrypt from 'jsencrypt'
Vue.use(ElementUI)
Vue.use(VuereSource);
Vue.use(infiniteScroll);
Vue.config.productionTip = false
//全局方法
Vue.prototype.cookieHelper = cookie;
//随机数
Vue.prototype.uidHelper = uid;
//密码加密
Vue.prototype.jsencryptHelper = jsencrypt;

Vue.prototype.$api = api; // 将api挂载到vue的原型上

api.mainpageApi.getMainPageConfig().then(response => {
    Vue.prototype.$supMainPageConfig = response.data.data;
    new Vue({
        data: {
            supMainPageConfig: function () {
                api.mainpageApi.getMainPageConfig().then(response => {
                    return response.data.data
                })
            }
        },
        render: h => h(App),
    }).$mount('#app');
});



